import { useState, useRef } from "react";
import React from "react";

const CreateEmailSignup = (data) => {
  const formData = new FormData();
  formData.append("email", data.email);
  return formData;
};

export { CreateEmailSignup };
